import { render } from "./MyCardHeader.vue?vue&type=template&id=63d5a28b"
import script from "./MyCardHeader.vue?vue&type=script&lang=js"
export * from "./MyCardHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__